<template>
  <div>
  <HomeLayout bg_icon='none' v-if="$mq === 'md'">
    <div class="col-sm-8 col-sm-offset-3 center-text">
      <h2 >select your plan</h2>

      <div class="alert alert-danger" v-if="error">
        <p v-if="error" class="error">{{ error.message }}</p>
      </div>

      <div class="plan-selection">
        <div class="plan">
          <div class="plan-top trial">
            <div class="plan-name">trial</div>
            <div class="plan-cost">$0</div>
            <div class="plan-interval">for 14 days</div>
          </div>
          <div class="plan-details">
            <ul>
              <li><strong>no credit card required</strong></li>
              <li>1 tutorial</li>
              <li>50 views</li>
              <li>&nbsp;</li>
            </ul>
            <a href="/tutorials" class="waves-effect waves-light btn trial">CONTINUE</a>
          </div>
        </div>
        <div class="plan">
          <div class="plan-top gemini">
            <div class="plan-name">gemini</div>
            <div class="plan-cost">$0</div>
            <div class="plan-interval">per month</div>
          </div>
          <div class="plan-details">
            <ul>
              <li><strong>up to 300 views per month</strong></li>
              <li>template + viewer</li>
              <li>10 tutorials</li>
              <li>1 user</li>
            </ul>
            <a v-on:click="checkout('gemini')" class="gemini waves-effect waves-light btn">START FOR FREE</a>
          </div>
        </div>

        <div class="plan">
          <div class="plan-top apollo">
            <div class="plan-name">apollo</div>
            <div class="plan-cost">$249</div>
            <div class="plan-interval">per month</div>
          </div>
          <div class="plan-details">
            <ul>
              <li><strong>up to 1000 views per month</strong></li>
              <li>template + viewer</li>
              <li>unlimited tutorials</li>
              <li>unlimited users</li>
            </ul>
            <a v-on:click="checkout('apollo')" class="apollo waves-effect waves-light btn">START FOR FREE</a>
          </div>
        </div>

        <div class="plan">
          <div class="plan-top dragon">
            <div class="plan-name">dragon</div>
            <div class="plan-cost">$499</div>
            <div class="plan-interval">per month</div>
          </div>
          <div class="plan-details">
            <ul>
              <li><strong>up to 1,500 views per month</strong></li>
              <li>template + viewer</li>
              <li>unlimited tutorials</li>
              <li>unlimited users</li>
            </ul>
            <a v-on:click="checkout('dragon')" class="dragon waves-effect waves-light btn">START FOR FREE</a>
          </div>
        </div>



      </div>


    </div>
  </HomeLayout>



  <MobileLayout v-if="$mq === 'sm'" v-bind:class="{ confirmed: confirmed }">
    <div class="heading-card card row">
      <div class="col s2 left-card">
          <div class="bg">
            <div class="bg-icon-wrapper">
                <div><i class='material-icons bg-icon'>lock_outline</i></div>
            </div>
        </div>
      </div>
      <div class="col s10">
        <h1 v-if="confirmed">thanks for not being a bot<br/> beep...bop...boop</h1>
        <h1 v-else>welcome back<br/>thanks for using fyiio</h1>
      </div>
    </div>
    <div class="alert alert-danger" v-if="error">
      <p v-if="error" class="error">{{ error.message }}</p>
    </div>
    <form @submit.prevent="login">
      <div class="form-card card">
        <input id="inputUsername" type="text" class="text-white form-control" placeholder="email" v-model="username"  autocomplete="off"  required>

        <input id="inputPassword" type="password" class="form-control" placeholder="password" v-model="pass"  autocomplete="off"  required>
      </div>
      <button class="btn btn-primary blue">login</button>
      <p class="white-text">
        forgot your password? </br> <router-link class="orange-text" to="/reset_password">reset password</router-link>.
      </p>

    </form>
  </MobileLayout>
  </div>
</template>

<script>
import HomeLayout from '@/containers/layouts/HomeLayout'
import MobileLayout from '@/containers/layouts/MobileLayout'
import cognitoAuth from '@/plugins/cognito'

export default {
  mounted () {
    var self = this;
    cognitoAuth.getUserAttributes(function(err, user_attributes) {
      self.email = user_attributes.email;
      self.loading = false;

    })
  },
  data () {
    return {
      confirmed: this.$route.query.confirmed || false,
      username: this.$route.query.username || '',
      pass: '',
      error: null
    }
  },
  methods: {
    updateCustomerId: function(customer_id) {
      var self = this;

      this.$cognitoAuth.updateCustomerId(customer_id, (err, result) => {
        if (err) {
          console.log("update name error: ", err)
          this.error = err
        } else {
          this.$router.replace('/tutorials')

        }
      })

    },
    checkout(plan) {
      // This is older code, saved to show structure, place use the StripeApi object to make the calls
      // so that the endpoint is relevant to environment
      var self = this;
      var params = {
        name: 'Subscribe',
        currency: 'USD',
        name: "Apollo",
        email: this.email,
        description: "up to 1000 views per month",
        amount: 29999,
        token: (token) => {
          fetch('https://gyehvhc24f.execute-api.us-east-1.amazonaws.com/dev/createSubscription', {
            method: 'post',
            mode: 'cors',
            body: JSON.stringify(token),
            headers: {
              'Accept': 'application/json',
              // 'Authorization': jwttoken
            }

          }).then(function(data) {return data.json()}).then(response => {
            self.updateCustomerId(response.customer)
          }).catch(err => {
            console.log ('err ', err)
          })
        }
      }

      if (plan == 'apollo') {
        params = Object.assign(params, {
          amount: 24900,
          name: 'apollo',
          description: 'up to 1000 views per month'
        })
      } else if (plan == 'dragon') {
        params = Object.assign(params, {
          amount: 49900,
          name: 'dragon',
          description: 'up to 1,500 views per month'
        })
      } else if (plan == 'gemini') {
        params = Object.assign(params, {
          amount: "free",
          name: 'gemini',
          description: 'up to 10 tutorials and 1 quiz'
        })
      }
      this.$checkout.open(params);
    },

  },
  components: {
    HomeLayout, MobileLayout
  }
}
</script>

<style lang="postcss" scoped>
.error {
  color: red;
}
p {
  margin-left: 10px;
}
h2 {
  text-align: center;
}
.mobileLayout {
  background-image: url('./../../assets/pond.png');
  background-size: cover;
}
.mobileLayout.confirmed {
  background-image: url('./../../assets/droids.png');
  background-size: cover;
}
.forgot-password {
  font-size: 14px!important;
  color: rgba(0, 0, 0, .54);

}
.forgot-password a {
  display: inline-block;
}

.plan-selection {
  display: flex;
  padding-left: 3em;
  padding-right: 3em;
}
.plan {
  flex-basis: 25%;
  text-align:center;
  border: 1px solid gray;
  margin: 1em;
}

.plan-details .btn {
  margin-bottom: 1em;
  bottom: 0px;
}
.marketing {
  text-align: right;
  padding-right: 5em;
}

.plan-top {
  color: white;
  background-color: gray;
  padding: 1em;
}
.plan-name {
  font-size: 24px;
}
.plan-cost {
  font-size: 48px;
}

.trial {
  background: -moz-linear-gradient(to top, rgba(89,90,92,1) 0%, rgba(146,148,151,1) 100%);
// background: -webkit-gradient(left top, right top, color-stop(0%, rgba(89,90,92,1)), color-stop(100%, rgba(146,148,151,1)));
  background: -webkit-linear-gradient(to top, rgba(89,90,92,1) 0%, rgba(146,148,151,1) 100%);
  background: -o-linear-gradient(to top, rgba(89,90,92,1) 0%, rgba(146,148,151,1) 100%);
  background: -ms-linear-gradient(to top, rgba(89,90,92,1) 0%, rgba(146,148,151,1) 100%);
  background: linear-gradient(to top, rgba(89,90,92,1) 0%, rgba(146,148,151,1) 100%);
}

.trial.btn{
  min-width: 172px;;
  background: -moz-linear-gradient(to right, rgba(89,90,92,1) 0%, rgba(146,148,151,1) 100%);
// background: -webkit-gradient(left top, right top, color-stop(0%, rgba(89,90,92,1)), color-stop(100%, rgba(146,148,151,1)));
  background: -webkit-linear-gradient(to right, rgba(89,90,92,1) 0%, rgba(146,148,151,1) 100%);
  background: -o-linear-gradient(to right, rgba(89,90,92,1) 0%, rgba(146,148,151,1) 100%);
  background: -ms-linear-gradient(to right, rgba(89,90,92,1) 0%, rgba(146,148,151,1) 100%);
  background: linear-gradient(to right, rgba(89,90,92,1) 0%, rgba(146,148,151,1) 100%);
}


.apollo {
  background: -moz-linear-gradient(to bottom right, rgba(64,171,225,1) 0%, rgba(83,168,158,1) 100%);
  background: -webkit-gradient(left top, right top, color-stop(0%, rgba(64,171,225,1)), color-stop(100%, rgba(83,168,158,1)));
  background: -webkit-linear-gradient(to bottom right, rgba(64,171,225,1) 0%, rgba(83,168,158,1) 100%);
  background: -o-linear-gradient(to bottom right, rgba(64,171,225,1) 0%, rgba(83,168,158,1) 100%);
  background: -ms-linear-gradient(to bottom right, rgba(64,171,225,1) 0%, rgba(83,168,158,1) 100%);
  background: linear-gradient(to bottom right, rgba(64,171,225,1) 0%, rgba(83,168,158,1) 100%);
}
.apollo.btn {
  background: -moz-linear-gradient(to right, rgba(64,171,225,1) 0%, rgba(83,168,158,1) 100%);
  background: -webkit-gradient(left top, right top, color-stop(0%, rgba(64,171,225,1)), color-stop(100%, rgba(83,168,158,1)));
  background: -webkit-linear-gradient(to right, rgba(64,171,225,1) 0%, rgba(83,168,158,1) 100%);
  background: -o-linear-gradient(to right, rgba(64,171,225,1) 0%, rgba(83,168,158,1) 100%);
  background: -ms-linear-gradient(to right, rgba(64,171,225,1) 0%, rgba(83,168,158,1) 100%);
  background: linear-gradient(to right, rgba(64,171,225,1) 0%, rgba(83,168,158,1) 100%);
}

.dragon {
background: -moz-linear-gradient(to bottom right, rgba(83,168,157,1) 0%, rgba(232,113,165,1) 100%);
background: -webkit-gradient(left top, right top, color-stop(0%, rgba(83,168,157,1)), color-stop(100%, rgba(232,113,165,1)));
background: -webkit-linear-gradient(to bottom right, rgba(83,168,157,1) 0%, rgba(232,113,165,1) 100%);
background: -o-linear-gradient(to bottom right, rgba(83,168,157,1) 0%, rgba(232,113,165,1) 100%);
background: -ms-linear-gradient(to bottom right, rgba(83,168,157,1) 0%, rgba(232,113,165,1) 100%);
background: linear-gradient(to bottom right, rgba(83,168,157,1) 0%, rgba(232,113,165,1) 100%);
}
.dragon.btn {
background: -moz-linear-gradient(to right, rgba(83,168,157,1) 0%, rgba(232,113,165,1) 100%);
background: -webkit-gradient(left top, right top, color-stop(0%, rgba(83,168,157,1)), color-stop(100%, rgba(232,113,165,1)));
background: -webkit-linear-gradient(to right, rgba(83,168,157,1) 0%, rgba(232,113,165,1) 100%);
background: -o-linear-gradient(to right, rgba(83,168,157,1) 0%, rgba(232,113,165,1) 100%);
background: -ms-linear-gradient(to right, rgba(83,168,157,1) 0%, rgba(232,113,165,1) 100%);
background: linear-gradient(to right, rgba(83,168,157,1) 0%, rgba(232,113,165,1) 100%);
}

.gemini {
  background: -moz-linear-gradient(to bottom right, rgba(232,113,165,1) 0%, rgba(246,176,64,1) 100%);
background: -webkit-gradient(left top, right top, color-stop(0%, rgba(232,113,165,1)), color-stop(100%, rgba(246,176,64,1)));
background: -webkit-linear-gradient(to bottom right, rgba(232,113,165,1) 0%, rgba(246,176,64,1) 100%);
background: -o-linear-gradient(to bottom right, rgba(232,113,165,1) 0%, rgba(246,176,64,1) 100%);
background: -ms-linear-gradient(to bottom right, rgba(232,113,165,1) 0%, rgba(246,176,64,1) 100%);
background: linear-gradient(to bottom right, rgba(232,113,165,1) 0%, rgba(246,176,64,1) 100%);
}
.gemini.btn {
  background: -moz-linear-gradient(to  right, rgba(232,113,165,1) 0%, rgba(246,176,64,1) 100%);
background: -webkit-gradient(left top, right top, color-stop(0%, rgba(232,113,165,1)), color-stop(100%, rgba(246,176,64,1)));
background: -webkit-linear-gradient(to  right, rgba(232,113,165,1) 0%, rgba(246,176,64,1) 100%);
background: -o-linear-gradient(to  right, rgba(232,113,165,1) 0%, rgba(246,176,64,1) 100%);
background: -ms-linear-gradient(to  right, rgba(232,113,165,1) 0%, rgba(246,176,64,1) 100%);
background: linear-gradient(to  right, rgba(232,113,165,1) 0%, rgba(246,176,64,1) 100%);
}
</style>



// WEBPACK FOOTER //
// src/containers/authentication/PlanSelection.vue